<template lang="pug">
  .lei-toggle
    .lei-toggle__container
      button.lei-toggle__button(
        :class="{'lei-toggle__selected': !challengeMode}"
        :disabled="!challengeMode"
        @click="cancelChanges"
        )  {{toggleLabelOne}}
      button.lei-toggle__button(
        :class="{'lei-toggle__selected': challengeMode}"
        :disabled="challengeMode"
        @click="openChallengeMode"
        data-test="enter-challenge-mode-button"
        ) {{toggleLabelTwo}}
</template>
<script>

import { mapMutations, mapGetters, mapState, } from 'vuex'
import {
  CLEAR_CHALLENGE,
} from '@/store/modules/record/modules/challenge/mutations-types'
import { TOGGLE_DISPLAY_SECTION, } from '@/store/modules/record/mutations-types'
import { TOGGLE_AUTH_MODAL, } from '@/store/modules/auth/mutations-types'
import { EventBus, } from '@/event-bus'
import { scrollTop, } from '@/utils/helpers'
import Challenge from '@/mixins/challenge'




export default {
  name: 'ToggleChallenge',
  mixins: [ Challenge, ],
  props: {
    toggleLabelOne: {
      type: String,
      default: 'Data',
    },
    toggleLabelTwo: {
      type: String,
      default: 'Challenge',
    },
  },
  data () {
    return {
      currentState: false,
      confirmText: 'You are leaving this page, if you proceed all entered data will be lost. ' +
          'Do you want to leave this page?',
    }
  },
  computed: {
    ...mapGetters('auth', [ 'authUser', ]),
    ...mapState('record', [ 'showEmptyFields', ]),
  },

  mounted () {
    EventBus.$on('summary-save', () => {
      this.clearChallenge()
      EventBus.$emit('challenge-clear')
      this.toggleDisplayEmptyFields(this.currentState)
      this.$router.push({ name: 'RecordDetailsPage', })
    })
    EventBus.$on('logged-in', this.startChallenge)
  },
  beforeDestroy () {
    EventBus.$off('summary-save')
    EventBus.$off('logged-in')
  },

  methods: {
    openChallengeMode () {
      !this.authUser ? this.toggleAuthModal(true) : this.startChallenge()
    },
    startChallenge () {
      scrollTop()
      this.currentState = this.showEmptyFields
      this.toggleDisplayEmptyFields(true)
      if (!this.challengeMode) this.$router.push({ name: 'Challenge', })
    },
    cancelChanges () {
      this.$confirm(this.confirmText, {
        type: 'warning',
      }).then(() => {
        this.toggleDisplayEmptyFields(this.currentState)
        this.clearChallenge()
        EventBus.$emit('challenge-clear')
        this.$router.push({ name: 'RecordDetailsPage', })
        this.$message({
          type: 'info',
          message: 'Challenge canceled',
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Challenge continues',
        })
      })

    },
    toggleDisplayEmptyFields (value) {
      this.toggleDisplay({
        property: 'showEmptyFields',
        value,
      })
    },

    ...mapMutations('record/challenge', {
      clearChallenge: CLEAR_CHALLENGE,
    }),
    ...mapMutations('record', {
      toggleDisplay: TOGGLE_DISPLAY_SECTION,
    }),
    ...mapMutations('auth', {
      toggleAuthModal: TOGGLE_AUTH_MODAL,
    }),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .lei-toggle
    display flex
    align-items center
    align-self flex-end
    @media (max-width: $laptop)
      padding 0 20px 30px
    @media (max-width: $mobile)
      padding 0 20px
    &__container
      background-color $primary-color-light-3
      border 1px solid $primary-color-light-4
      border-radius 25px
      width 200px
      height $input-sm
      position relative
      margin 0.5rem 0 2rem
      @media (max-width: $laptop)
        margin 0.5rem 0 1.2rem




    &__selected
      background-color $turquoise-color  !important
      color $cyprus-color !important
      cursor auto !important


    &__button
      min-width 100px
      height $input-sm
      align-items center
      justify-content center
      padding 5px 20px
      font-size 90%
      font-weight bold
      cursor pointer
      border-radius 25px
      border none
      background-color transparent
      color $cyprus-color
      position absolute
      top -1px
      &:first-child
        left -1px
      &:last-child
        right -1px

      &:hover
        color $turquoise-color

</style>



// WEBPACK FOOTER //
// src/components/challenge-components/ToggleChallenge.vue